module.exports = __webpack_public_path__ + "static/media/overview.5575dd90.svg";